import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { UsersListInterface } from "../../../../../redux/interfaces/admin.interface";

export const usersTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Id",
    value: "id",
    minW: 125,
  },
  {
    label: "Username",
    value: "username",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Nume",
    value: "lastName",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Prenume",
    value: "firstName",
    minW: 125,
    withSearch: true,
  },
];

export const getUsersTableData = (data: UsersListInterface[]): TableData[] =>
  data.map((item) => {
    const deletedUser = item.deleted === 1;
    return {
      id: item.userId,
      crudData: item,
      data: [
        {
          title: item.userId,
          titleStyle: { color: deletedUser && "red" },
        },
        {
          title: item.userName,
          titleStyle: { color: deletedUser && "red" },
        },
        {
          title: item.nume,
          titleStyle: { color: deletedUser && "red" },
        },
        {
          title: item.prenume,
          titleStyle: { color: deletedUser && "red" },
        },
      ],
    };
  });
